import React, { useEffect } from "react";

/**
 * Pont web → app native. Cette page est chargée DANS le navigateur intégré
 * (SFSafariViewController / Custom Tab) à la fin du login Google Emergent :
 * elle relaie immédiatement le fragment #session_id=… vers l'app via le
 * custom scheme neldaari:// (capté par NativeAuthListener / appUrlOpen).
 * Le flux web classique (/auth/callback) reste inchangé.
 */
export default function AuthNativeBridge() {
  const appUrl = "neldaari://auth/callback" + (window.location.hash || "");

  useEffect(() => {
    window.location.href = appUrl;
  }, [appUrl]);

  return (
    <div className="min-h-[70vh] grid place-items-center px-6 text-center" data-testid="auth-native-bridge">
      <div>
        <div className="font-display text-lg font-bold mb-2">Retour vers l'app NelDaari…</div>
        <p className="text-sm text-mute mb-4">Returning to the NelDaari app…</p>
        <a
          href={appUrl}
          data-testid="auth-native-bridge-open"
          className="inline-flex rounded-full bg-brand-red text-white px-6 py-3 text-sm font-semibold"
        >
          Ouvrir NelDaari / Open NelDaari
        </a>
      </div>
    </div>
  );
}
